import React, { useState, useEffect } from 'react';
import api from '../services/api';

function BotConfig() {
  const [options, setOptions] = useState({ Options: {} });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const data = await api.get('/config/options');
        setOptions(data);
      } catch (err) {
        console.error('Failed to fetch options:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchOptions();
  }, []);

  const handleChange = (key, value) => {
    setOptions(prev => ({
      ...prev,
      Options: { ...prev.Options, [key]: value },
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage(null);
    try {
      await api.put('/config/options', options);
      setMessage({ type: 'success', text: 'Options saved successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to save options.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="card">Loading...</div>;

  const opts = options.Options || {};

  return (
    <div>
      <div className="page-header">
        <h2>Bot Configuration</h2>
        <p>Configure L2Walker bot options and settings</p>
      </div>

      {message && (
        <div className={`alert alert-${message.type}`}>{message.text}</div>
      )}

      <div className="card">
        <div className="card-title">General Settings</div>
        <div className="form-group">
          <label>Window Title</label>
          <input
            type="text"
            value={opts.Title || ''}
            onChange={e => handleChange('Title', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Server</label>
          <input
            type="text"
            value={opts.Server || ''}
            onChange={e => handleChange('Server', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Token</label>
          <input
            type="text"
            value={opts.Token || ''}
            onChange={e => handleChange('Token', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Offset</label>
          <input
            type="text"
            value={opts.OffSet || ''}
            onChange={e => handleChange('OffSet', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Token2</label>
          <input
            type="text"
            value={opts.Token2 || ''}
            onChange={e => handleChange('Token2', e.target.value)}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-title">Toggles</div>
        <div className="form-group">
          <label>GM Fix</label>
          <select
            value={opts.GMFix || '0'}
            onChange={e => handleChange('GMFix', e.target.value)}
          >
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
        <div className="form-group">
          <label>Rename</label>
          <select
            value={opts.Rename || '0'}
            onChange={e => handleChange('Rename', e.target.value)}
          >
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
      </div>

      <div className="btn-group">
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Configuration'}
        </button>
      </div>
    </div>
  );
}

export default BotConfig;
